import React from 'react';
import Button from 'components/Global/Button';
import { addDays, format } from 'date-fns';
import { ReactComponent as DateIcon } from 'icons/calendar-icon.svg';
import { ReactComponent as ChevronDown } from 'icons/chevron-down.svg';
import { useRef } from 'react';
import { useEffect } from 'react';
import { useState } from 'react';
import SelectFieldZone from 'components/Global/SelectfieldZone';
import { useAppContext } from 'components/Context/AppContext';
import { setCurrency } from 'utils/functionality';
import { useSelector } from 'react-redux';
import InputField from 'components/Global/InputField';
import { getLocationTimezone } from 'utils/getTimezone';
import SelectFieldShuttleZone from 'components/Global/SelectFieldShuttleZone';
import CheckboxField from 'components/Global/CheckboxField';
import SelectFieldTime from 'components/Global/SelectFieldTime';
import { useFliptBoolean } from '@flipt-io/flipt-client-react';
import { trackEvent } from 'utils/analytics';
import clsx from 'clsx';
import TextAreaInput from 'components/Global/TextArea';

// BOOKING ZONE INITIAL STATE
const initialBookingZones = {
  date: '',
  pickup_zone_id: 0,
  detail_pickup_location: '',
  pickup_zone_price: 0,
  drop_off_zone_id: 0,
  detail_drop_off_location: '',
  drop_off_zone_price: 0,
  driving_zone_id: 0,
  driving_zone_price: 0,
  booking_start_time: '',
  booking_end_time: '',
  overtime_duration: 0,
  total_price: 0,
  pickup_list_zone_id: 0,
  drop_off_list_zone_id: 0,
  driving_list_zone_id: 0,
  detail_driving_location: '',
  is_driver_stay_overnight: false,
  driver_stay_overnight_price: 0,
  customer_name_meet_and_greet: '',
};

const ZoneListForm = ({
  idx,
  item,
  handleOpen,
  startDate,
  accordionNumberOpen,
  setAccordionNumberOpen,
  durationRentDate,
  allBookingZone,
  setAllBookingZone,
  isOrderConfirmation,
  zoneData,
  forCustomOrder,
  rentalLocation,
  dayDuration,
  isFirstLoad,
  currency = 'IDR',
  updateDataOrder,
  transactionKey,
}) => {
  const formRef = useRef(null);

  const { showToast } = useAppContext();

  const { data: summaryOrderData } = useSelector((state) => state.summaryOrder);
  const { zoneList } = useSelector((state) => state.zone);

  const [bookingZoneData, setBookingZoneData] = useState(initialBookingZones);
  const [pickupLocation, setPickupLocation] = useState('');
  const [pickupLocationDetail, setPickupLocationDetail] = useState('');
  const [dropoffLocation, setDropoffLocation] = useState('');
  const [dropoffLocationDetail, setDropoffLocationDetail] = useState('');
  const [drivingLocation, setDrivingLocation] = useState('');
  const [highestZone, setHighestZone] = useState('');
  const [totalPriceZone, setTotalPriceZone] = useState(0);
  const [showFlightInput, setShowFlightInput] = useState(false);
  const [landingHour, setLandingHour] = useState('');
  const [flightNumber, setFlightNumber] = useState('');
  const [isMeetAndGreetBoardRequire, setIsMeetAndGreetBoardRequire] = useState(false);
  const [boardMessage, setBoardMessage] = useState('');
  const [itinerary, setItinerary] = useState('');

  const [isSaved, setIsSaved] = useState(false);

  const isImprovUpdateDataEnabled = useFliptBoolean('FLAG_FE_IMPROVEMENT_UPDATE_DATA_ORDER', false, 'anonymous');
  const isNewDriverAccomodationFeeJakartaEnabled = useFliptBoolean(
    'FLAG_FE_NEW_DRIVER_ACCOMODATION_FEE_JAKARTA',
    false,
    'anonymous',
  );
  const isFieldItineraryJakartaEnabled = useFliptBoolean('FLAG_FE_FIELD_ITIENARARY_JAKARTA', false, 'anonymous');

  const handlePickupLocation = (zone) => {
    setPickupLocation(`${zone.name} (${zone.name_zone})`);

    if (zone.region_type_name?.toLowerCase() === 'airport') {
      setShowFlightInput(true);
    } else {
      setShowFlightInput(false);
      setFlightNumber('');
      setLandingHour('');
      setIsMeetAndGreetBoardRequire(false);
      setBoardMessage('');
      setPickupLocationDetail('');
      setDropoffLocationDetail('');
    }

    setBookingZoneData({
      ...bookingZoneData,
      pickup_zone_id: zone.zone_id,
      pickup_list_zone_id: zone.id,
      detail_pickup_location: `${zone.name} (${zone.name_zone})`,
      ...(zone.region_type_name?.toLowerCase() !== 'airport' && {
        flight_number: '',
        landing_time: '',
      }),
    });
    setIsSaved(false);
  };

  const handlePickupLocationDetail = (e) => {
    setPickupLocationDetail(e.target.value);

    setBookingZoneData({
      ...bookingZoneData,
      detail_pickup_location_placeholder: e.target.value,
    });
    setIsSaved(false);
  };

  const handleDropoffLocation = (zone) => {
    setDropoffLocation(`${zone.name} (${zone.name_zone})`);

    setBookingZoneData({
      ...bookingZoneData,
      drop_off_zone_id: zone.zone_id,
      drop_off_list_zone_id: zone.id,
      detail_drop_off_location: `${zone.name} (${zone.name_zone})`,
    });
    setIsSaved(false);
  };

  const handleDropoffLocationDetail = (e) => {
    setDropoffLocationDetail(e.target.value);

    setBookingZoneData({
      ...bookingZoneData,
      detail_drop_off_location_placeholder: e.target.value,
    });
    setIsSaved(false);
  };

  const handleFlightNumber = (e) => {
    setFlightNumber(e.target.value);

    setBookingZoneData({
      ...bookingZoneData,
      flight_number: e.target.value,
    });
    setIsSaved(false);
  };

  const handleLandingTime = (hour, minute) => {
    setLandingHour(`${hour}:${minute ? minute : '00'}`);

    setBookingZoneData({
      ...bookingZoneData,
      landing_time: `${hour}:${minute ? minute : '00'}`,
    });
    setIsSaved(false);
  };

  const drivingZoneHandler = (e) => {
    setDrivingLocation(e.target.value);
    const drivingZoneId = zoneData?.find((item) => item.name === e.target.value)?.id;

    setBookingZoneData({
      ...bookingZoneData,
      driving_zone_id: drivingZoneId,
      detail_driving_location: e.target.value,
      driving_list_zone_id: 0,
    });
    setIsSaved(false);
  };

  const checkAccommodationHandler = (e) => {
    const checked = e.target.checked;
    setBookingZoneData({
      ...bookingZoneData,
      is_driver_stay_overnight: checked,
    });
    setIsSaved(false);
  };

  const checkMeetAndGreetBoardHandler = (e) => {
    const check = e.target.checked;
    if (!check) {
      setBoardMessage('');
    }
    setIsMeetAndGreetBoardRequire(check);
    setIsSaved(false);
  };

  const handleItinerary = (e) => {
    setItinerary(e.target.value);

    setBookingZoneData({
      ...bookingZoneData,
      itinerary: e.target.value,
    });
    setIsSaved(false);
  };

  // SAVE BOOKING ZONE DATA
  const saveBookingZoneData = () => {
    // validation
    const validPickUpLocation = bookingZoneData.pickup_zone_id;
    const validPickUpLocationDetail = bookingZoneData.detail_pickup_location_placeholder;
    const validDropoffLocation = bookingZoneData.drop_off_zone_id;
    const validDropoffLocationDetail = bookingZoneData.detail_drop_off_location_placeholder;
    const validZoneArea = bookingZoneData.driving_zone_id;
    const validStartBookingTime = dayDuration[idx]?.booking_start_time;
    const validEndBookingTime = dayDuration[idx]?.booking_end_time;
    const validFlightInfo = bookingZoneData.flight_number && bookingZoneData.landing_time;
    const validMeetAndGreetBoard = boardMessage && boardMessage !== '';
    const validItinerary = itinerary.trim() !== '';

    if (!validPickUpLocation && item === 1) {
      return showToast({ type: 'error', message: 'Pilih Lokasi Penjemputan' });
    } else if (!validDropoffLocation && item === durationRentDate) {
      return showToast({ type: 'error', message: 'Pilih Lokasi Pengantaran' });
    } else if (!validZoneArea) {
      return showToast({ type: 'error', message: 'Pilih Area Penyewaan' });
    } else if (!validStartBookingTime) {
      return showToast({ type: 'error', message: 'Pilih Tanggal Mulai' });
    } else if (!validEndBookingTime) {
      return showToast({ type: 'error', message: 'Pilih Tanggal Selesai' });
    } else if (!validPickUpLocationDetail) {
      return showToast({ type: 'error', message: 'Harap Isi Detail Lokasi Pickup' });
    } else if (!validDropoffLocationDetail) {
      return showToast({ type: 'error', message: 'Harap Isi Detail Lokasi Dropoff' });
    } else if (isMeetAndGreetBoardRequire && !validMeetAndGreetBoard && showFlightInput) {
      return showToast({ type: 'error', message: 'Masukan Meet And Greet Board' });
    }

    if (showFlightInput && !validFlightInfo) {
      return showToast({ type: 'error', message: 'Harap Isi Detail Penerbangan' });
    }

    if (isFieldItineraryJakartaEnabled && rentalLocation?.name?.toLowerCase() === 'jakarta' && !validItinerary) {
      return showToast({ type: 'error', message: 'Harap Isi Informasi Area Penyewaan' });
    }

    const copyArrAllBookingZoneData = [...allBookingZone];
    copyArrAllBookingZoneData[idx] = {
      ...bookingZoneData,
      date: format(addDays(startDate, idx), 'yyyy-MM-dd'),
      booking_start_time: dayDuration[idx]?.booking_start_time,
      booking_end_time: dayDuration[idx]?.booking_end_time,
      overtime_duration: dayDuration[idx]?.overtime_duration || 0,
      customer_name_meet_and_greet: boardMessage,
      use_meet_greet_board: isMeetAndGreetBoardRequire,
    };

    const zonePickup = zoneList?.list_zones?.find(
      (zone) => `${zone.name} (${zone.name_zone})` === pickupLocation,
    )?.name_zone;
    const zoneDropoff = zoneList?.list_zones?.find(
      (zone) => `${zone.name} (${zone.name_zone})` === dropoffLocation,
    )?.name_zone;

    setHighestZone(
      [zonePickup, zoneDropoff, drivingLocation].sort((a, b) => +a.charAt(a.length - 1) - +b.charAt(b.length - 1))[2],
    );
    setAllBookingZone(copyArrAllBookingZoneData);
    setIsSaved(true);

    if (item === durationRentDate) {
      setAccordionNumberOpen(0);
    } else {
      setAccordionNumberOpen(item + 1);
    }
  };

  const getAccommodationPrice = () => {
    if (isNewDriverAccomodationFeeJakartaEnabled) {
      if (zoneList?.list_zones?.[0]?.name_location?.toLowerCase() === 'jakarta') return 250000;
    }

    return 200000;
  };

  const showDriverAccommodationComponent = () => {
    if (!isNewDriverAccomodationFeeJakartaEnabled) {
      return (
        <div className="form-booking-zone__input-data__driver-accommodation">
          <div className="check">
            <CheckboxField
              htmlfor={`checkbox-accommodation$-${item}`}
              name={`checkbox-accommodation$-${item}`}
              checked={bookingZoneData.is_driver_stay_overnight}
              onChange={checkAccommodationHandler}
              readOnly
              disable={isOrderConfirmation}
            />
          </div>
          <div className="description">
            <h5>Akomodasi Driver</h5>
            <p>
              Customer akan dikenakan biaya tambahan untuk akomodasi driver (Penginapan) untuk sewa lebih dari 2 hari
              dan ada biaya tambahan yang dikenakan sebesar <span>{setCurrency(200000, currency)}</span> / Hari
            </p>
          </div>
        </div>
      );
    }

    if (forCustomOrder || bookingZoneData.is_driver_stay_overnight) {
      return (
        <div className="form-booking-zone__input-data__driver-accommodation">
          <div className="check">
            <CheckboxField
              htmlfor={`checkbox-accommodation$-${item}`}
              name={`checkbox-accommodation$-${item}`}
              checked={bookingZoneData.is_driver_stay_overnight}
              onChange={checkAccommodationHandler}
              readOnly
              disable={isOrderConfirmation}
            />
          </div>
          <div className="description">
            <h5>Akomodasi Driver</h5>
            <p>
              Customer akan dikenakan biaya tambahan untuk akomodasi driver (Penginapan) untuk sewa lebih dari 2 hari
              dan ada biaya tambahan yang dikenakan sebesar{' '}
              <span>{setCurrency(getAccommodationPrice(), currency)}</span> / Hari
            </p>
          </div>
        </div>
      );
    }

    trackEvent('admin_accommodation_followup_viewed', { order_id: transactionKey });
    return (
      <div className="form-booking-zone__input-data__no-driver-accommodation">
        <div className="check">
          <CheckboxField
            htmlfor={`checkbox-accommodation$-${item}`}
            name={`checkbox-accommodation$-${item}`}
            readOnly
            disable={isOrderConfirmation}
          />
        </div>
        <div className="description">
          <div className="follow-up">
            <h5>Akomodasi Driver</h5>
            <div className="badge">
              <p>Perlu Follow-up Akomodasi</p>
            </div>
          </div>
          <p>
            Customer akan dikenakan biaya tambahan untuk akomodasi driver (Penginapan) untuk sewa lebih dari 2 hari dan
            ada biaya tambahan yang dikenakan sebesar <span>{setCurrency(getAccommodationPrice(), currency)}</span> /
            Hari
          </p>
        </div>
      </div>
    );
  };

  const showItineraryComponent = () => {
    if (isFieldItineraryJakartaEnabled && rentalLocation?.name?.toLowerCase() === 'jakarta') {
      if (itinerary || forCustomOrder) {
        trackEvent('admin_itinerary_viewed', { order_id: transactionKey, city: rentalLocation?.name?.toLowerCase() });
        return (
          <div className="form-booking-zone__input-data__itinerary">
            <TextAreaInput
              label="Informasi Area Penyewaan"
              id={`itinerary-${item}`}
              value={itinerary}
              onChange={handleItinerary}
              placeholder="Tuliskan Informasi Area Penyewaan"
              disable={isOrderConfirmation}
              className="itinerary-textarea"
            />
          </div>
        );
      }

      return (
        <div className="form-booking-zone__input-data__no-itinerary">
          <p>Tidak ada Itinerary</p>
        </div>
      );
    }

    return null;
  };

  // SET BOOKING ZONE DATA WHEN THE DATA HAS BEEN ENTERED BEFORE
  useEffect(() => {
    if (!isFirstLoad && !updateDataOrder) return;
    if (!zoneData || !zoneData.length) return;
    if (!allBookingZone || allBookingZone.length === 0) return;

    if (allBookingZone.length >= item) {
      setBookingZoneData({
        booking_end_time: allBookingZone[idx].booking_end_time,
        booking_start_time: allBookingZone[idx].booking_start_time,
        date: allBookingZone[idx].date,
        pickup_zone_id: allBookingZone[idx].pickup_zone_id,
        detail_pickup_location: allBookingZone[idx].detail_pickup_location,
        pickup_zone_price: allBookingZone[idx].pickup_zone_price,
        drop_off_zone_id: allBookingZone[idx].drop_off_zone_id,
        detail_drop_off_location: allBookingZone[idx].detail_drop_off_location,
        drop_off_zone_price: allBookingZone[idx].drop_off_zone_price,
        driving_zone_id: allBookingZone[idx].driving_zone_id,
        driving_zone_price: allBookingZone[idx].driving_zone_price,
        overtime_duration: allBookingZone[idx].overtime_duration,
        pickup_list_zone_id: allBookingZone[idx].pickup_list_zone_id,
        drop_off_list_zone_id: allBookingZone[idx].drop_off_list_zone_id,
        driving_list_zone_id: allBookingZone[idx].driving_list_zone_id,
        detail_driving_location: allBookingZone[idx].detail_driving_location,
        is_driver_stay_overnight: allBookingZone[idx].is_driver_stay_overnight,
        driver_stay_overnight_price: allBookingZone[idx].driver_stay_overnight_price,
        flight_number: allBookingZone[idx].flight_number,
        landing_time: allBookingZone[idx].landing_time,
        total_price:
          Object.keys(summaryOrderData).length !== 0 && summaryOrderData.order_zone_price?.length > 0
            ? summaryOrderData?.order_zone_price[idx]?.total_price
            : allBookingZone[idx].total_price,
        customer_name_meet_and_greet: allBookingZone[idx].customer_name_meet_and_greet || '',
        use_meet_greet_board: allBookingZone[idx].use_meet_greet_board,
        ...(isImprovUpdateDataEnabled && {
          detail_pickup_location_placeholder:
            allBookingZone[idx]?.detail_pickup_location_placeholder ??
            allBookingZone[idx]?.detail_pickup_location?.split(' - ')?.[1],
          detail_drop_off_location_placeholder:
            allBookingZone[idx]?.detail_drop_off_location_placeholder ??
            allBookingZone[idx]?.detail_drop_off_location?.split(' - ')?.[1],
        }),
      });

      let bookingPickupLocation;
      let bookingDropoffLocation;
      let bookingDrivingLocation = zoneData?.find((item) => item.id === allBookingZone[idx].driving_zone_id)?.name;

      if (!allBookingZone[idx].detail_pickup_location) {
        setPickupLocation(zoneData?.find((item) => item.id == allBookingZone[idx]?.pickup_zone_id)?.name);
        bookingPickupLocation = zoneData?.find((item) => item.id == allBookingZone[idx]?.pickup_zone_id)?.name;
      } else {
        const pickupLocation = allBookingZone[idx]?.detail_pickup_location?.split(' - ')?.[0];
        setPickupLocation(pickupLocation);
        bookingPickupLocation =
          allBookingZone[idx]?.detail_pickup_location?.match(/\((.*?)\)/)?.length > 0
            ? allBookingZone[idx]?.detail_pickup_location?.match(/\((.*?)\)/)[1]
            : '';
      }

      if (!allBookingZone[idx].detail_drop_off_location) {
        setDropoffLocation(zoneData?.find((item) => item.id == allBookingZone[idx]?.drop_off_zone_id)?.name);
        bookingDropoffLocation = zoneData?.find((item) => item.id == allBookingZone[idx]?.drop_off_zone_id)?.name;
      } else {
        const dropoffLocation = allBookingZone[idx]?.detail_drop_off_location?.split(' - ')?.[0];
        setDropoffLocation(dropoffLocation);
        bookingDropoffLocation =
          allBookingZone[idx]?.detail_drop_off_location?.match(/\((.*?)\)/)?.length > 0
            ? allBookingZone[idx]?.detail_drop_off_location?.match(/\((.*?)\)/)[1]
            : '';
      }

      if (allBookingZone[idx].detail_pickup_location_placeholder) {
        setPickupLocationDetail(allBookingZone[idx]?.detail_pickup_location_placeholder);
      } else {
        // To handle data from API
        const detailPickup = allBookingZone[idx]?.detail_pickup_location?.split(' - ')?.[1];
        setPickupLocationDetail(detailPickup);
      }

      if (allBookingZone[idx].detail_drop_off_location_placeholder) {
        setDropoffLocationDetail(allBookingZone[idx]?.detail_drop_off_location_placeholder);
      } else {
        // To handle data from API
        const detailDropoff = allBookingZone[idx]?.detail_drop_off_location?.split(' - ')?.[1];
        setDropoffLocationDetail(detailDropoff);
      }

      if (allBookingZone[idx].landing_time || allBookingZone[idx].flight_number) {
        setShowFlightInput(true);
        setFlightNumber(allBookingZone[idx].flight_number);
        setLandingHour(allBookingZone[idx].landing_time);
      }

      setDrivingLocation(bookingDrivingLocation);

      setHighestZone(
        [bookingPickupLocation, bookingDropoffLocation, bookingDrivingLocation].sort(
          (a, b) => +a.charAt(a.length - 1) - +b.charAt(b.length - 1),
        )[2],
      );

      if (allBookingZone[idx].customer_name_meet_and_greet && allBookingZone[idx].use_meet_greet_board) {
        setIsMeetAndGreetBoardRequire(true);
        setBoardMessage(allBookingZone[idx].customer_name_meet_and_greet);
      }

      if (allBookingZone[idx].is_driver_stay_overnight) {
        const totalPrice =
          Object.keys(summaryOrderData).length !== 0
            ? summaryOrderData?.order_zone_price[idx]?.total_price
            : allBookingZone[idx].total_price;
        const accommodationDriverPrice =
          Object.keys(summaryOrderData).length !== 0
            ? summaryOrderData?.order_zone_price[idx]?.driver_stay_overnight_price
            : allBookingZone[idx].driver_stay_overnight_price;

        if (isMeetAndGreetBoardRequire) {
          let meetAndGreetBoardPrice;
          if (forCustomOrder) {
            meetAndGreetBoardPrice = summaryOrderData?.order_zone_price[idx]?.fee_meet_greet_board || 0;
          } else {
            meetAndGreetBoardPrice = allBookingZone[idx]?.fee_meet_greet_board || 0;
          }
          setTotalPriceZone(totalPrice + accommodationDriverPrice + meetAndGreetBoardPrice);
        } else {
          setTotalPriceZone(totalPrice + accommodationDriverPrice);
        }
      } else {
        const totalPrice =
          Object.keys(summaryOrderData).length !== 0 && summaryOrderData.order_zone_price?.length > 0
            ? summaryOrderData?.order_zone_price[idx]?.total_price
            : allBookingZone[idx].total_price;

        if (isMeetAndGreetBoardRequire) {
          let meetAndGreetBoardPrice;
          if (forCustomOrder) {
            meetAndGreetBoardPrice = summaryOrderData?.order_zone_price[idx]?.fee_meet_greet_board || 0;
          } else {
            meetAndGreetBoardPrice = allBookingZone[idx]?.fee_meet_greet_board || 0;
          }
          setTotalPriceZone(totalPrice + meetAndGreetBoardPrice);
        } else {
          setTotalPriceZone(totalPrice);
        }
      }

      if (isFieldItineraryJakartaEnabled) {
        setItinerary(allBookingZone[idx]?.itinerary || '');
      }

      setIsSaved(true);
    }
  }, [allBookingZone, zoneData, durationRentDate, isFirstLoad]);

  // SET TOTAL PRICE ZONE
  useEffect(() => {
    if (!Object.keys(summaryOrderData).length) return;
    if (!summaryOrderData.order_zone_price?.length) return;

    const totalPrice = summaryOrderData?.order_zone_price[idx]?.total_price;
    const accommodationDriverPrice = summaryOrderData?.order_zone_price[idx]?.driver_stay_overnight_price;
    const meetAndGreetBoardPrice = summaryOrderData?.order_zone_price[idx]?.fee_meet_greet_board || 0;

    if (isMeetAndGreetBoardRequire && boardMessage) {
      setTotalPriceZone(totalPrice + accommodationDriverPrice + meetAndGreetBoardPrice);
    } else {
      setTotalPriceZone(totalPrice + accommodationDriverPrice);
    }
  }, [summaryOrderData]);

  const timezone = !rentalLocation?.time_zone_identifier
    ? ''
    : getLocationTimezone(rentalLocation?.time_zone_identifier);

  useEffect(() => {
    if (isFirstLoad) return;

    setBookingZoneData({
      booking_end_time: allBookingZone[idx]?.booking_end_time,
      booking_start_time: allBookingZone[idx]?.booking_start_time,
      date: allBookingZone[idx]?.date,
      pickup_zone_id: 0,
      detail_pickup_location: '',
      detail_pickup_location_placeholder: '',
      pickup_zone_price: 0,
      drop_off_zone_id: 0,
      detail_drop_off_location: '',
      detail_drop_off_location_placeholder: '',
      drop_off_zone_price: 0,
      driving_zone_id: 0,
      driving_zone_price: 0,
      overtime_duration: 0,
      pickup_list_zone_id: 0,
      drop_off_list_zone_id: 0,
      driving_list_zone_id: 0,
      detail_driving_location: '',
      is_driver_stay_overnight: false,
      driver_stay_overnight_price: 0,
      total_price: 0,
    });

    setHighestZone('');
    setPickupLocation('');
    setPickupLocationDetail('');
    setDropoffLocation('');
    setDropoffLocationDetail('');
    setDrivingLocation('');
    setTotalPriceZone(0);
    setFlightNumber('');
    setLandingHour('');
    setIsSaved(false);
  }, [durationRentDate]);

  return (
    <li className="list-booking-zone">
      {/* HEADER LIST */}
      <div className="header" onClick={() => handleOpen(item)}>
        <div className="header__date">
          <div>
            <DateIcon />
            <span>Day-{item}</span>
          </div>
          <div>
            <span />
            <p>{!isNaN(startDate) && format(addDays(startDate, idx), 'dd MMMM yyyy')}</p>
          </div>
          <div
            className={`selected-zone ${
              highestZone == 'Zona 0' ? 'zone-zero' : highestZone == 'Zona 1' ? 'zone-one' : 'zone-two'
            }`}
            style={{ display: isOrderConfirmation ? 'block' : isSaved ? 'block' : 'none' }}
          >
            {highestZone}
          </div>
          <div
            className="selected-zone-price"
            style={{ display: isOrderConfirmation ? 'block' : isSaved ? 'block' : 'none' }}
          >
            <span>{`(${setCurrency(totalPriceZone || 0, currency)})`}</span>
          </div>
        </div>
        <ChevronDown className={`chevron ${accordionNumberOpen === item ? 'up' : 'down'}`} />
      </div>

      {/* BODY LIST */}
      <div className={clsx('form-booking-zone', accordionNumberOpen === item && 'active')}>
        <div ref={formRef} className="form-booking-zone__wrapper">
          {/* INPUT FORM */}
          <div className="form-booking-zone__input-data">
            <SelectFieldShuttleZone
              label="PickUp"
              id={`pickup-${item}`}
              value={pickupLocation}
              onChange={handlePickupLocation}
              placeholder="Pilih Zona Pick Up"
              disable={isOrderConfirmation}
            />

            <SelectFieldShuttleZone
              label="Drop Off"
              id={`dropoff-${item}`}
              value={dropoffLocation}
              onChange={handleDropoffLocation}
              placeholder="Pilih Zona Drop Off"
              disable={isOrderConfirmation}
            />

            <InputField
              label=""
              id={`pickup-detail-${item}`}
              value={pickupLocationDetail}
              onChange={handlePickupLocationDetail}
              placeholder="Tuliskan Detail Lokasi Pick Up"
              disable={isOrderConfirmation}
            />

            <InputField
              label=""
              id={`dropoff-detail-${item}`}
              value={dropoffLocationDetail}
              onChange={handleDropoffLocationDetail}
              placeholder="Tuliskan Detail Lokasi Drop Off"
              disable={isOrderConfirmation}
            />

            {/* TAMBAH AREA PENYEWAAN */}
            <SelectFieldZone
              label="Tambah Area Penyewaan"
              id={`area-penyewaan-tambahan-${item}`}
              placeholder="Pilih Area Penyewaan"
              value={drivingLocation}
              onChange={drivingZoneHandler}
              disable={isOrderConfirmation}
            />

            {showItineraryComponent()}

            {!forCustomOrder ? (
              <>
                <div className="form-booking-zone__time">
                  <InputField
                    label="Jam Mulai"
                    value={(bookingZoneData?.booking_start_time || '') + ' ' + timezone}
                    disable={isOrderConfirmation}
                    readOnly
                  />
                  <InputField
                    label="Jam Selesai"
                    value={(bookingZoneData?.booking_end_time || '') + ' ' + timezone}
                    disable={isOrderConfirmation}
                    readOnly
                  />
                </div>
                <InputField
                  label="Overtime"
                  value={
                    bookingZoneData?.overtime_duration > 0
                      ? bookingZoneData?.overtime_duration
                      : 'Tidak Ada Overtime' || ''
                  }
                  disable={isOrderConfirmation}
                  readOnly
                />
              </>
            ) : null}

            {showFlightInput && (
              <div className="form-booking-zone__input-data__flight-info">
                <InputField
                  label="No. Penerbangan"
                  htmlFor="no-penerbangan"
                  placeholder="Tulis No. Penerbangan"
                  value={flightNumber}
                  onChange={handleFlightNumber}
                  disable={isOrderConfirmation}
                />
                <SelectFieldTime
                  label="Estimasi Mendarat"
                  htmlFor="landing-hour"
                  placeholder="00:00"
                  value={landingHour}
                  onChange={handleLandingTime}
                  disable={isOrderConfirmation}
                  showAllHours={true}
                />
              </div>
            )}

            {showFlightInput && (summaryOrderData?.meet_greet_board?.is_active || isMeetAndGreetBoardRequire) && (
              <div className="form-booking-zone__input-data__meet-greet-board">
                <CheckboxField
                  label="Meet&Greet Board (Optional)"
                  name="meet-greet-board"
                  value="meet-greet-board"
                  className="meet-greet-board-checkbox"
                  checked={isMeetAndGreetBoardRequire}
                  onChange={checkMeetAndGreetBoardHandler}
                  disable={isOrderConfirmation}
                />
                <InputField
                  label="Meet and Greet Board"
                  htmlFor={'meet-and-greet-board' + idx}
                  placeholder="Welcome Big Ben!”, “Ben”, etc"
                  value={boardMessage}
                  onChange={(e) => setBoardMessage(e.target.value)}
                  disable={isOrderConfirmation || !isMeetAndGreetBoardRequire}
                />
              </div>
            )}

            {/* DRIVER ACCOMODATION */}
            {item < durationRentDate && showDriverAccommodationComponent()}
          </div>

          {/* BUTTON */}
          <div className="form-booking-zone__action-button">
            {isOrderConfirmation ? null : (
              <Button
                type="button"
                variant="primary"
                style={{
                  background: '#F1A33A',
                  width: '104px',
                }}
                onClick={saveBookingZoneData}
                disabled={isSaved}
              >
                Simpan
              </Button>
            )}
          </div>
        </div>
      </div>
    </li>
  );
};

export default ZoneListForm;
